(function ($) {
    $.fn.header = function () {
        this.each((i, el) => {
            const $self = $(el);
            const $headerContainer = $self.children('.container');
            const $mobileMenuToggle = $self.find('.mobile-menu-toggle');
            let $searchModal = $('#searchModal');
            const $mobileMenu = $self.find('.nav-primary-mobile');
            const $searchIcon = $headerContainer.find('.contact-search .search');
            const $searchIconLink = $searchIcon.find('a');
            const $searchIconMobile = $self.find('.mobile-btn .search-mobile a');
            const $searchBox = $searchModal.find('.navbar-search-box');
            const $searchPage = $searchBox.attr('data-search-page');
            

            // let scrolled = 0;

            $mobileMenuToggle.on('click', () => {
                $headerContainer.toggleClass('mobile-menu-visible');
            });

            $mobileMenu.find('li').on('click', (e) => {
                const $target = $(e.target);
                if ($target.is('li.menu-item-has-children')) {
                    $mobileMenu
                        .find('li.expanded')
                        .not($target)
                        .removeClass('expanded')
                        .find('.sub-menu')
                        .css('height', 0);
                    if (!$target.hasClass('expanded')) {
                        $target.addClass('expanded');
                        let height = 0;
                        $target.find('.sub-menu li').each((index, element) => {
                            height += $(element).outerHeight();
                        });

                        /** Set calculated height on first 'sub-menu', and auto height on inner submenus */
                        $target.find('.sub-menu').each((i, el) => {
                            const $el = $(el);
                            if(i > 0){
                                $el.css('height', 'auto');
                            }else{
                                $el.css('height', height);
                            }
                        });
                    } else {
                        $target.removeClass('expanded');
                        $target.find('.sub-menu').css('height', 0);
                    }
                }
            });

            $searchIconMobile.on('click', (event) => {
                event.preventDefault();
                var $searchResuls =
                    document.getElementsByClassName('search-results')[0];
                if ($searchResuls) {
                    var $searchInput = $searchResuls.querySelector(
                        '.container .search-form .form .field-wrap input'
                    );

                    $searchInput.focus();
                    return;
                }
                redirectToSearchResutsPageFromMobile();
            });

            $searchIcon.on('click', (event) => {
                event.preventDefault();
                var $searchResuls =
                    document.getElementsByClassName('search-results')[0];
                if ($searchResuls) {
                    var $searchInput = $searchResuls.querySelector(
                        '.container .search-form .form .field-wrap input'
                    );

                    $searchInput.focus();
                    return;
                }

                $searchIconLink.addClass('search-box-visible');
                $.frModalOpen($searchModal);
            });

            $searchModal.on('fr:afterHideModal', () => {
                $searchIconLink.removeClass('search-box-visible');
            });

            $searchBox.find('a').on('click', (event) => {
                event.preventDefault();
                redirectToSearchResultsPage();
            });

            $searchBox.find('[type=text').on('keyup', (event) => {
                event.preventDefault();
                if (event.key === 'Enter' || event.keyCode === 13) {
                    redirectToSearchResultsPage();
                }
            });

            function redirectToSearchResultsPage() {
                const searchText = $searchBox.find('[type=text]').val();
                if (searchText.length > 0) {
                    window.location.replace($searchPage + '?search=' + searchText);
                }
            }

            function redirectToSearchResutsPageFromMobile() {
                window.location.replace($searchPage);
            }

            // $(window).on('scroll', () => {
            //     if (window.scrollY > $self.height()) {
            //         $self.addClass('fixed');
            //         scrolled > window.scrollY
            //             ? $self.addClass('visible')
            //             : $self.removeClass('visible');
            //         window.scrollY > 200
            //             ? $self.addClass('transition')
            //             : $self.removeClass('transition');
            //     } else {
            //         $self.removeClass('fixed');
            //     }
            //     scrolled = window.scrollY;
            // });

            if(navigator.appVersion.indexOf('iPhone') >= 0) {
                $('body').addClass('iPhone');
            }

            // var $scrollTop = $('.header').offset().top;
            // alert($scrollTop);
            //     var $scrollTop = $('.banner').offset().top;
            // window.addEventListener('scroll', function() {



                // if ($scrollTop > 110) { alert('if');
                //     if (window.scrollTop() > $scrollTop) {
                //         // if (!$self.hasClass('headerup') && $mobileNavBar.hasClass('opened')) {
                //         //     $mobileToggleButton.trigger('click');
                //         // }
                //         $self.addClass('headerup');
                //     } else {
                //         $self.removeClass('headerup');
                //     }

                //     $self.addClass('sticky-active');
                // } else{
                //     alert('else');
                // }
            // });

            var scrolled = 0;
            $(window).on('scroll', () => { 
                    if (window.scrollY > $self.height() + 10) { 
                        $self.addClass('scrolled');
                        if(scrolled < window.scrollY) {
                            $self.addClass('headerup');
                        } else {
                            $self.removeClass('headerup');
                        }
                    } else { 
                        $self.removeClass('scrolled');
                        $self.removeClass('headerup');
                    }

                scrolled = window.scrollY;
            });
        });

        return this;
    };

    $(() => {
        $('body').children('.banner').header();
    });
})($);



// WEBPACK FOOTER //
// ./scripts/modules/header.js